

import React from "react";

const PartialsTab = (props) => {
  const { selected, updateStatus, updating } = props
  console.log("after update", selected)
  return (

    <div className="flex items-center gap-2">
      <table
        className={{
          borderCollapse: "collapse",
          width: "100%",
          minWidth: 500,
          fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
        }}
      >
        <thead>
          <tr>

            <th className={"ths"}>{"Reference"}</th>
            <th className={"ths"}>{"Code client"}</th>
            <th className={"ths"}>{"Raison Sociale"}</th>
            <th className={"ths"}>{"Code client revendeur"}</th>
            <th className={"ths"}>{"Raison sociale revendeur"}</th>
            <th className={"ths"}>{"Status"}</th>
            <th className={"ths"}>{"Date création"}</th>
            <th className={"ths"}>{"date modification"}</th>        
          </tr>
        </thead>
        <tbody>
          {!selected ? (
            <tr>
              <td className={"tds"} colSpan={4}>{"Aucune donnée"}</td>
            </tr>
          ) : (
            <tr key={1}>           
              <td className={"tds"}>{selected.reference}</td>
              <td className={"tds"}>{selected.client_code}</td>
              <td className={"tds"}>{selected.client_name}</td>
              <td className={"tds"}>{selected.partner_code}</td>
              <td className={"tds"}>{selected.partner_name}</td>
              <td className={"tds"}>{selected.status}</td>
              <td className={"tds"}>{selected.created}</td>
              <td className={"tds"}>{selected.modified}</td>    
            </tr>
          )}
        </tbody>
      </table>
      <button className="button step-navigation__next medium primary" onClick={(e) => updateStatus(selected.status)} disabled={updating}>{"Mettre en partiel"}</button>
    </div>
  );
};
export default PartialsTab;
